import { useEffect, useState } from "react";
import { Icon } from "@wordpress/components";

export const CustomSearchButton= ({ value, onChange, onSubmit, onClear,onBlur }) => {
  const [searchTerm, setSearchTerm] = useState(value || '');
  const [borderColor, setBorderColor] = useState("transparent");
  const [inputClass, setInputClass] = useState("");

  useEffect(() => {
    setSearchTerm(value);
  }, [value]);

  const handleChange = (e) => {
    const trimmedValue = e.target.value;
    setSearchTerm(trimmedValue);
    if (onChange) {
      onChange(trimmedValue);
    }
  };

  const handleSubmit = () => {
    const trimmed = searchTerm.trim();
    if (trimmed.length === 0) {
      if (onChange) onChange(""); // Optional: Clear parent too
      setBorderColor("red");
      setInputClass("__error");

      setTimeout(() => {
        setBorderColor("transparent");
        setInputClass("");
      }, 300);
    } else if (onSubmit) {
      onSubmit(trimmed);
    }
  };

  const handleClear = () => {
    setSearchTerm('');
    if (onClear) {
      onClear();
    }
    if (onSubmit) {
      onSubmit('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
  };

  const containerStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    
  };

  const wrapperStyles = {
    position: 'relative',
    width: '100%',
  };

  const inputStyles = {
    width: '100%',
    height: '40px',
    padding: '0px 36px 0px 12px',
    border: `1px solid ${borderColor}`,
    borderRadius: '2px',
    backgroundColor: '#f3f4f6',
    outline: 'none'
  };

  const buttonStyles = {
    position: 'absolute',
    right: '8px',
    top: '50%',
    transform: 'translateY(-50%)',
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    color: '#6b7280',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0'
  };

  return (
    <div className={"image-hub-search-control "+inputClass} style={containerStyles}>
      <div style={wrapperStyles}>
        <input
          type="text"
          value={searchTerm}
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          style={inputStyles}
          onBlur={onBlur}
          maxLength={100}
          placeholder="Search..."
        />
        <button
          onClick={searchTerm ? handleClear : handleSubmit}
          style={buttonStyles}
          aria-label={searchTerm ? "Clear search" : "Search"}
        >
          <Icon icon={searchTerm ? "no-alt" : "search"} size={20} />
        </button>
      </div>
    </div>
  );
};
